import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { deletePublicApiToken, selector as deleteTokenApi } from './deletePublicTokenSlice';
import { getCookie } from '../../common/utils';
import useNotification from '../notification/useNotification';
import { listPublicApiTokens } from '../../pages/integrations/flashcast/listPublicApiTokenSlice'; // refresh list
import { useSpinner } from "../../customHooks";

export const useDeletePublicTokenModal = (id?: string) => {
  const [tokenId, setTokenId] = useState<string>(id ?? '');
  const [show, setShow] = useState(false);
  const dispatch: any = useDispatch();

  const { showSuccessNotification, showWarningNotification } = useNotification();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const deleteTokenResponse = useSelector(deleteTokenApi);
  useSpinner(deleteTokenResponse.status);
  const handleDeleteButtonClick = () => {
    const orgId = getCookie('organizationId');
    dispatch(deletePublicApiToken({ entryId: tokenId, orgId }))
      .then((response: any) => {
        if (response.meta && response.meta.requestStatus === 'fulfilled') {
          showSuccessNotification(response.payload.message);
          dispatch(listPublicApiTokens()); // refresh table
        } else {
          showWarningNotification(response.payload?.response?.data?.message || "Failed to delete token");
        }
      })
      .catch(() => {
        showWarningNotification("Something went wrong while deleting");
      });
      setShow(false);
  };

  return {
    show,
    handleDeleteButtonClick,
    handleClose,
    handleShow,
    setTokenId
  };
};
